import { render, staticRenderFns } from "./NossosCartoes.vue?vue&type=template&id=3c45ef86&"
import script from "./NossosCartoes.vue?vue&type=script&lang=js&"
export * from "./NossosCartoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports